import { isUrlPatterMatchOrNot } from "Components/NavBar/navBarHelper";
import useGlobalSearchContext from "Context/GlobalSearchContext";

const useMoreButton = () => {
  const { globalSearchData, saveGlobalSearchData } = useGlobalSearchContext();
  const checkPathWithIdOrNot = (path: string) => {
    if (path != undefined && path != null) {
      if (path.includes("myBranch")) {
        return isUrlPatterMatchOrNot(location.pathname, /\/myBranch\/([^/]+)$/);
      } else if (path.includes("mybatch")) {
        if (globalSearchData && globalSearchData.isFilterVisibale) {
          return isUrlPatterMatchOrNot(
            location.pathname,
            /\/mybatch\/([^/]+)$/
          );
        }
      } else if (path.includes("batches")) {
        return isUrlPatterMatchOrNot(location.pathname, /\/batches\/([^/]+)$/);
      } else return false;
    }
  };
  const handleSearchIcon = (path: any) => {
    if (path === "/admin/myBranch") {
      return saveGlobalSearchData({
        pathurl: path,
        isBranchHealth: true,
        isStudentHealth: false,
        isPerformance: false,
        isSyllabusCompliances: false,
        isBatches: false,
        isMyBatch: false,
      });
    } else if (path === "/admin/myBranch/") {
      return saveGlobalSearchData({
        pathurl: path,
        isStudentHealth: true,
        isBranchHealth: false,
        isPerformance: false,
        isSyllabusCompliances: false,
        isBatches: false,
        isMyBatch: false,
      });
    } else if (
      path === "/admin/performance" ||
      isUrlPatterMatchOrNot(location.pathname, /\/performance\/(\d+)$/)
    ) {
      return saveGlobalSearchData({
        pathurl: path,
        isStudentHealth: false,
        isBranchHealth: false,
        isPerformance: true,
        isSyllabusCompliances: false,
        isBatches: false,
        isMyBatch: false,
      });
    } else if (
      isUrlPatterMatchOrNot(location.pathname, /\/myBranch\/([^/]+)$/)
    ) {
      return saveGlobalSearchData({
        pathurl: path,
        isStudentHealth: true,
        isBranchHealth: false,
        isPerformance: false,
        isBatches: false,
        isMyBatch: false,
      });
    } else if (path === "/admin/batches") {
      return saveGlobalSearchData({
        pathurl: path,
        isStudentHealth: false,
        isBranchHealth: false,
        isPerformance: false,
        isMyBatch: false,
        isBatches: true,
      });
    } else if (
      isUrlPatterMatchOrNot(location.pathname, /\/batches\/([^/]+)$/)
    ) {
      return saveGlobalSearchData({
        pathurl: path,
        isStudentHealth: false,
        isBranchHealth: false,
        isPerformance: false,
        isMyBatch: false,
        isBatches: true,
      });
    } else if (
      isUrlPatterMatchOrNot(location.pathname, /\/mybatch\/([^/]+)$/)
    ) {
      return saveGlobalSearchData({
        pathurl: path,
        isStudentHealth: false,
        isBranchHealth: false,
        isPerformance: false,
        isBatches: false,
        isMyBatch: true,
      });
    } else if (path === "/admin/syllabusCompliances") {
      return saveGlobalSearchData({
        pathurl: path,
        isStudentHealth: false,
        isBranchHealth: false,
        isPerformance: false,
        isSyllabusCompliances: true,
      });
    } else if (path === "/admin/faculties/regions") {
      return saveGlobalSearchData({
        pathurl: path,
        isStudentHealth: false,
        isBranchHealth: false,
        isPerformance: false,
        isSyllabusCompliances: false,
        isFaculties: true,
      });
    } else if (path === "/admin/schedule") {
      return saveGlobalSearchData({
        pathurl: path,
        isStudentHealth: false,
        isBranchHealth: false,
        isPerformance: false,
        isSyllabusCompliances: false,
        isFaculties: false,
        isSchedule: true,
      });
    } else if (path === "/admin/dashboard") {
      return saveGlobalSearchData({
        pathurl: path,
        isStudentHealth: false,
        isBranchHealth: false,
        isPerformance: true,
        isSyllabusCompliances: false,
        isBatches: false,
        isMyBatch: false,
      });
    } else if (path === "/admin/schedule-beta") {
      console.log("pathpath", path);
      return saveGlobalSearchData({
        pathurl: path,
        isStudentHealth: false,
        isBranchHealth: false,
        isPerformance: false,
        isSyllabusCompliances: false,
        isBatches: false,
        isMyBatch: false,
        isScheduleBeta: true,
      });
    } else {
      // Handle other cases or default behavior here
    }
  };
  return {
    checkPathWithIdOrNot,
    handleSearchIcon,
  };
};

export default useMoreButton;
